// removed by extract-text-webpack-plugin
module.exports = {"root":"js-components-CatastrophicErrorDisplay-module__root--UwjHo","errorContainer":"js-components-CatastrophicErrorDisplay-module__errorContainer--s8c6a"};